import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const isTweetResolver: FieldResolver = (metadata: Metadata) =>
  ({ isTweet: metadata.isTweet() } as StreamData)

export default isTweetResolver
